import { createContext } from 'react'

const PhishingContext = createContext()

export default PhishingContext
